<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
  [tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle"
  [status]="status"
  [msg]="statusMsg"
  [token]="token">

  <ng-container *ngIf="consulta">

    <h2 class="subtitle">DADOS CADASTRAIS</h2>
    <ul class="card-list-striped">
      <li><span class="text-secondary">Placa </span><span>{{consulta?.placa || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Chassi </span><span>{{consulta?.chassi || "NÃO INFORMADO"}}</span>
      </li>
      <li><span class="text-secondary">Ano de fabricação
        </span><span>{{consulta?.anoFabricacao || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Ano do modelo
        </span><span>{{consulta?.anoModelo || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Modelo </span><span>{{consulta?.modelo || "NÃO INFORMADO"}}</span>
      </li>
      <li><span class="text-secondary">Situação chassi
        </span><span>{{consulta?.situacaoChassi || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Combustível
        </span><span>{{consulta?.combustivel || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Cor </span><span>{{consulta?.cor || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Renavam </span><span>{{consulta?.renavam || "NÃO INFORMADO"}}</span>
      </li>
      <li><span class="text-secondary">Segmento
        </span><span>{{consulta?.segmento || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Subsegmento
        </span><span>{{consulta?.subSegmento || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Nr Motor </span><span>{{consulta?.nrMotor || "NÃO INFORMADO"}}</span>
      </li>
      <li><span class="text-secondary">Nr Câmbio </span><span> {{consulta?.nrCambio || "NÃO INFORMADO"}} /
          {{consultaVeiculo?.binestadual?.uf || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Nr Carroceria
        </span><span>{{consulta?.nrCarroceria || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Nr Eixo traseiro
        </span><span>{{consulta?.nrEixoTraseiro || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Quantidade de eixos
        </span><span>{{consulta?.quantidadeEixos || "NÃO INFORMADO"}}</span></li>
    </ul>

    <h2 class="subtitle subtitle-danger ">RATING</h2>
    <ul class="card-list card-list-striped">
      <li><span class="text-secondary">Score/Pontuação
        </span><span>{{consulta?.scorePontuacao || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Aceitação veiculo
        </span><span>{{consulta?.aceitacaoVeiculo || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Percentagem referência
        </span><span>{{consulta?.percentRef || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Exigência de vistoria
        </span><span>{{consulta?.exigVistEspec || "NÃO INFORMADO"}}</span></li>
    </ul>

    <h2 class="subtitle subtitle-danger ">CHECKLIST</h2>
    <ul class="card-list card-list-striped">
      <li><span class="text-secondary">Data de inspeção
        </span><span>{{consulta?.dataInspecao || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Motor </span><span>{{consulta?.motor || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Porta malas
        </span><span>{{consulta?.portaMalas || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Frente </span><span>{{consulta?.frente || "NÃO INFORMADO"}}</span>
      </li>
      <li><span class="text-secondary">Frente direita
        </span><span>{{consulta?.frenteDireita || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Frente esquerda
        </span><span>{{consulta?.frenteEsquerda || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Porta frente direita
        </span><span>{{consulta?.portaFrenteDireita || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Porta frente esquerda
        </span><span>{{consulta?.portaFrenteEsquerda || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Porta traseira direita
        </span><span>{{consulta?.portaTraseiraDireita || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Porta traseira esquerda
        </span><span>{{consulta?.portaTraseiraEsquerda || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Traseira direita
        </span><span>{{consulta?.traseiraDireita || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Traseira esquerda
        </span><span>{{consulta?.traseiraEsquerda || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Lado direito
        </span><span>{{consulta?.ladoDireito || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Lado esquerdo
        </span><span>{{consulta?.ladoEsquerdo || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Pneu frente direita
        </span><span>{{consulta?.pneuFrenteDireita || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Pneu frente esquerda
        </span><span>{{consulta?.pneuFrenteEsquerda || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Pneu traseira direita
        </span><span>{{consulta?.pneuTraseiraDireita || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Traseira
        </span><span>{{consulta?.traseira || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Caçamba </span><span>{{consulta?.cacamba || "NÃO INFORMADO"}}</span>
      </li>
      <li><span class="text-secondary">Bancos dianteiros
        </span><span>{{consulta?.bancosDianteiros || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Bancos traseiros
        </span><span>{{consulta?.bancosTraseiros || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Forro teto
        </span><span>{{consulta?.forroTeto || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Teto </span><span>{{consulta?.teto || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Carenagem dianteira
        </span><span>{{consulta?.carenagemDianteira || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Carenagem direita
        </span><span>{{consulta?.carenagemDireita || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Tanque combustível
        </span><span>{{consulta?.tanqueCombustivel || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Observação
        </span><span>{{consulta?.obsChecklist || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Link 1 </span><span>{{consulta?.link1 || "NÃO INFORMADO"}}</span>
      </li>
      <li><span class="text-secondary">Link 2 </span><span>{{consulta?.link2 || "NÃO INFORMADO"}}</span>
      </li>
      <li><span class="text-secondary">Garantia
        </span><span>{{consulta?.garantia || "NÃO INFORMADO"}}</span></li>
    </ul>

    <ng-container *ngIf="consulta?.lista && consulta?.lista?.length>0">
      <h2 class="subtitle subtitle-danger ">REMARKETINGS</h2>
      <div class="table-responsive">
        <table class="table-striped table-sm table table-striped">
          <tbody>
            <tr class="text-secondary">
              <th class="fw-500">Organizador</th>
              <th class="fw-500">Vendedor</th>
              <th class="fw-500">Item</th>
              <th class="fw-500">Data evento</th>
              <th class="fw-500">Sit chassi</th>
              <th class="fw-500">Cond veículo</th>
              <th class="fw-500">Cond chassi</th>
              <th class="fw-500">Cond motor</th>
              <th class="fw-500">Cond câmbio</th>
              <th class="fw-500">Observação</th>
            </tr>
            <tr *ngFor="let v of consulta?.lista">
              <td class="f-12">{{v?.organizador || "NÃO INFORMADO"}}</td>
              <td class="f-12">{{v?.vendedor || "NÃO INFORMADO"}}</td>
              <td class="f-12">{{v?.item || "NÃO INFORMADO"}}</td>
              <td class="f-12">{{v?.dataEvento || "NÃO INFORMADO"}}</td>
              <td class="f-12">{{v?.sitChassi || "NÃO INFORMADO"}}</td>
              <td class="f-12">{{v?.condVeiculo || "NÃO INFORMADO"}}</td>
              <td class="f-12">{{v?.condChassi || "NÃO INFORMADO"}}</td>
              <td class="f-12">{{v?.condMotor || "NÃO INFORMADO"}}</td>
              <td class="f-12">{{v?.condCambio || "NÃO INFORMADO"}}</td>
              <td class="f-12">{{v?.obs || "NÃO INFORMADO"}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
    <ng-container *ngIf="listaFotos.length>0">
      <h2 class="subtitle">FOTOS</h2>
      <div class="row p-1">
        <div *ngFor="let f of listaFotos" class="col-12 col-sm-6 col-md-4 col-lg-3 col-print-3 p-2">
          <button class="btn btn-primary p-0" (click)="openImgModal(f)">
            <img class="img-fluid rounded" src="{{f}}">
          </button>
        </div>
      </div>
    </ng-container>

  </ng-container>

</app-card-consulta>
